/**
 * Recent Order Prompt
 *
 * Gentle, dismissible homepage banner that offers a returning guest a one-click
 * route back to their most recently saved order-view link (this device only).
 * Renders nothing when there are no saved orders or the latest has been dismissed.
 */

import { Link, useParams } from 'react-router';
import { useGuestOrdersStore } from '@/stores/useGuestOrdersStore';

export function RecentOrderPrompt() {
  const locale = (useParams().locale as string) ?? 'en';
  const latest = useGuestOrdersStore((s) => s.orders[0]);
  const dismissedFor = useGuestOrdersStore((s) => s.promptDismissedFor);
  const dismissPrompt = useGuestOrdersStore((s) => s.dismissPrompt);

  if (!latest || dismissedFor === latest.token) return null;

  return (
    <div className="mx-auto mt-4 flex max-w-3xl items-center justify-between gap-4 rounded-xl border border-teal-200 bg-teal-50 px-4 py-3">
      <p className="text-sm text-teal-900">
        You have a recent order{latest.bookingReference ? ` (${latest.bookingReference})` : ''}.
      </p>
      <div className="flex items-center gap-3">
        <Link to={`/${locale}/orders/${latest.token}`} className="rounded-lg bg-teal-700 px-3 py-1.5 text-sm font-medium text-white hover:bg-teal-800">View</Link>
        <button type="button" aria-label="Dismiss" onClick={() => dismissPrompt(latest.token)} className="text-sm text-teal-700 hover:text-teal-900">Dismiss</button>
      </div>
    </div>
  );
}
